import { createProvideInject } from '@collector/shared-ui'

import { ManualAddIncidentConfig } from '../configuration'

export const [provideManualAddIncidentConfig, injectManualAddIncidentConfig] =
  createProvideInject<ManualAddIncidentConfig>('manualAddIncidentConfig')
